/**
 * 시드 기반 결정론 난수. `Math.random()`은 결정론을 깨뜨리므로 이 패키지에서는 금지.
 * mulberry32 — 빠르고 구현이 짧으며 서버/클라 양쪽에서 동일한 수열을 낸다.
 */
export interface Rng {
  /** [0, 1) */
  next(): number;
  /** [-1, 1) */
  signed(): number;
  /** [0, maxExclusive) 정수 */
  int(maxExclusive: number): number;
}

export function createRng(seed: number): Rng {
  // 32비트로 고정. 부호/실수 시드가 들어와도 같은 결과를 보장한다.
  let state = Math.imul(seed | 0, 1) >>> 0;
  if (state === 0) state = 0x9e3779b9;

  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  return {
    next,
    signed: () => next() * 2 - 1,
    int: (maxExclusive: number) => Math.floor(next() * maxExclusive),
  };
}
